import React, { useEffect, useState } from "react";
import Button from "../../components/ui/Button";
import { Header } from "../../components/ui/Header";
import Typograpy from "../../components/ui/Typography";
import moment from "moment";
import { getChartData } from "../../services/fxRates";
import MultipleLineChart from "./chart";
import Dropdown from "../../components/ui/Dropdown";

const symbols = [
  "USD",
  "EUR",
  "GBP",
  "AUD",
  "CAD",
  "SGD",
  "NZD",
  "AED",
  // "SAR",
  // "MUR",
  "JPY",
];

const FxRates = () => {
  const [duration, setDuration] = React.useState(1);
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [ratesArray, setRatesArray] = useState([]);
  const [datesArray, setDatesArray] = useState([]);
  const [graphData, setGraphData] = React.useState<any>();
  const [graphRatesArray, setGraphRatesArray] = useState([]);
  const [currentCurrency, setCurrentCurrency] = useState("USD");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const symbolsString = symbols.toString();

  useEffect(() => {
  }, [currentCurrency]);

  React.useEffect(() => {
    const today = new Date();
    const yesterday = new Date(today);

    yesterday.setDate(yesterday.getDate() - 1);
    const year = new Date(today);
    year.setDate(yesterday.getDate() - 365);
    let startDateValue = "";

    if (duration === 12) {
      startDateValue = moment(year).format("YYYY-MM-DD");
    } else if (duration === 6) {
      startDateValue = moment(yesterday).subtract(6, "months").format("YYYY-MM-DD");
    } else if (duration === 3) {
      startDateValue = moment(yesterday).subtract(3, "months").format("YYYY-MM-DD");
    } else if (duration === 1) {
      startDateValue = moment(yesterday).subtract(1, "months").format("YYYY-MM-DD");
    }

    const prevDate = moment(yesterday.toDateString()).format("YYYY-MM-DD");

    setStartDate(startDateValue);
    setEndDate(prevDate);
  }, [duration]);

  useEffect(() => {
    handleFxRates(startDate, endDate);
  }, [duration, currentCurrency, startDate, endDate]);

  const handleFxRates = (start: string, end: string) => {
    setIsLoading(true);
    const chartData = {
      symbolsString: symbolsString,
      startDate: start,
      endDate: end,
    };

    getChartData(chartData)
      .then((res) => {
        const dateArr: any = [],
          dataArr: any = [];

        const data = res.data.rates;
        Object.keys(data).map((item) => {
          dateArr.push(item);
          dataArr.push(data[item]);

          return { [item]: [data[item]] };
        });

        setDatesArray(dateArr);
        setRatesArray(dataArr);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleDropdown = () => {
    const dataArr: any = [];

    if (currentCurrency === "USD") {
      dataArr.length = 0;
      ratesArray.map((item: any) => {
        dataArr.push(1 / item.USD);
      });
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "EUR") {
      dataArr.length = 0;
      ratesArray.map((item: any) => {
        dataArr.push(1 / item.EUR);
      });
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "GBP") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.GBP));
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "AUD") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.AUD));
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "CAD") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.CAD));
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "SGD") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.SGD));
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "NZD") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.NZD));
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "AED") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.AED));
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "SAR") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.SAR));
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "MUR") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.MUR));
      setGraphRatesArray(dataArr);
    } else if (currentCurrency === "JPY") {
      dataArr.length = 0;
      ratesArray.map((item: any) => dataArr.push(1 / item.JPY));
      setGraphRatesArray(dataArr);
    }
  };

  useEffect(() => {
    handleDropdown();
  }, [ratesArray, datesArray, currentCurrency]);

  useEffect(() => {
    if (graphRatesArray && datesArray) {
      const mixedArray: any = graphRatesArray.map((rates: any, idx) => {
        return { date: datesArray[idx], rate: rates };
      });
      setGraphData(mixedArray);
    }
  }, [graphRatesArray, datesArray]);

  return (
    <div className="flex flex-col">
      <Header />
      <div className="flex items-center justify-between px-32 py-16">
        <Typograpy tagType="h1" className="text-xl font-semibold">
          FX Rates
        </Typograpy>
        <div className="flex items-center">
          <Button
            bgColor={duration === 12 ? "bg-[#E97C2E]" : "bg-primary"}
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="p-2 mr-4"
            onClickHandler={() => {
              setDuration(12);
            }}
          >
            1 Year
          </Button>
          <Button
            bgColor={duration === 6 ? "bg-[#E97C2E]" : "bg-primary"}
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="p-2 mr-4"
            onClickHandler={() => {
              setDuration(6);
            }}
          >
            6 Months
          </Button>
          <Button
            bgColor={duration === 3 ? "bg-[#E97C2E]" : "bg-primary"}
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="p-2 mr-4"
            onClickHandler={() => {
              setDuration(3);
            }}
          >
            3 Months
          </Button>
          <Button
            bgColor={duration === 1 ? "bg-[#E97C2E]" : "bg-primary"}
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="p-2 mr-8"
            onClickHandler={() => {
              setDuration(1);
            }}
          >
            1 Month
          </Button>
          <Dropdown
            showDropdown={showDropdown}
            dropdownButtonOnClick={() => setShowDropdown((prev) => !prev)}
            dropdownLabel="Currency"
            list={symbols}
            dropdownValue={currentCurrency}
            listItemOnClick={(e) => {
              e.stopPropagation();
              setCurrentCurrency(e.target.textContent);
              setShowDropdown(false);
            }}
            dropdownClassname="w-[60px]"
            dropdownBodyClassname="w-[120px]"
          />
        </div>
      </div>
      <div
        className="w-[90vw] h-[450px] p-10 border border-gray m-auto rounded-b-lg shadow-[0px_2px_0px_0px_rgba(236, 236, 236, 1)]"
        style={{ zoom: "117%" }}
      >
        {isLoading ? (
          "Fetching Data...."
        ) : (
          <MultipleLineChart data={graphData} graphRatesArray={graphRatesArray} />
        )}
      </div>
    </div>
  );
};

export default FxRates;
